<router-outlet></router-outlet>
@if (show) {
  <div class="loader">
    <div>
      <i class="bi bi-hourglass-split"></i>
      <span>{{'common.loading' |translate}}</span>
    </div>
  </div>
}
